/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

export type AssignmentStatus = typeof AssignmentStatus[keyof typeof AssignmentStatus];


export const AssignmentStatus = {
  open: 'open',
  overdue: 'overdue',
  completed: 'completed',
  completed_late: 'completed_late',
  draft: 'draft',
} as const;
